module.exports = __webpack_public_path__ + "img/dk.f7e4d769.svg";